// src/modules/components/Sidebar.js

import React from 'react';
import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';
import '../styles/SideBar.css'
import { useNavigate } from 'react-router-dom'; // Importa useNavigate

const MySidebar = ({ visible, onHide }) => {
    const navigate = useNavigate(); // Crea una instancia de useNavigate

    // Funciones para manejar la redirección
    const handleOption1Click = () => {
        navigate('/'); // Reemplaza con tu ruta
    };

    const handleOption2Click = () => {
        navigate('/inventario'); // Reemplaza con tu ruta
    };

    const handleOption3Click = () => {
        navigate('/listado_precios'); // Reemplaza con tu ruta
    };

    const handleOption4Click = () => {
        navigate('/listado_precios_generados'); // Reemplaza con tu ruta
    };

    const handleOption5Click = () => {
        navigate('/presupuesto'); // Reemplaza con tu ruta
    };

    const handleOption6Click = () => {
        navigate('/panel_compras'); // Reemplaza con tu ruta
    };

    const handleOption7Click = () => {
        navigate('/configuraciones'); // Reemplaza con tu ruta
    };

    const handleOption8Click = () => {
        navigate('/registro_contable'); // Reemplaza con tu ruta
    };

    const handleOption9Click = () => {
        navigate('/listado_presupuestos'); // Reemplaza con tu ruta
    };

    return (
        <Sidebar visible={visible} onHide={onHide} modal={false} position="left"
        style={{ height: '100vh', top: '5.2vw', maxWidth:"15vw" }} // Ajusta 'top' a la altura de tu header
        className="dark-sidebar" // Clase CSS para aplicar estilos oscuros
        >
            <h4 className="sidebar-title">Envasan</h4>
            <ul className="sidebar-menu">
                <li>
                    <Button 
                        label="Inicio"
                        icon="pi pi-home" 
                        className="sidebar-button" 
                        size='small'
                        onClick={handleOption1Click} 
                    />
                </li>
                <li>
                    <Button 
                        label="Presupuesto" 
                        icon="pi pi-file-pdf"
                        className="sidebar-button" 
                        size='small'
                        onClick={handleOption5Click} 
                    />
                </li>
                <li>
                    <Button 
                        label="Listado Presupuestos" 
                        icon="pi pi-book"
                        className="sidebar-button" 
                        size='small'
                        onClick={handleOption9Click} 
                    />
                </li>
                <li>
                    <Button 
                        label="Reposicion de Stock"
                        icon="pi pi-cart-plus"
                        className="sidebar-button" 
                        size='small'
                        onClick={handleOption6Click} 
                    />
                </li>
                <li>
                    <Button 
                        label="Inventario" 
                        icon="pi pi-receipt"
                        className="sidebar-button" 
                        size='small'
                        onClick={handleOption2Click} 
                    />
                </li>
                <li>
                    <Button 
                        label="Listado de Precios" 
                        icon="pi pi-file"
                        className="sidebar-button" 
                        size='small'
                        onClick={handleOption3Click} 
                    />
                </li>
                <li>
                    <Button 
                        label="Listados de Precios Generados"
                        icon="pi pi-file-check"
                        className="sidebar-button" 
                        size='small'
                        onClick={handleOption4Click} 
                    />
                </li>
                <li>
                    <Button 
                        label="Registro Contable"
                        icon="pi pi-money-bill"
                        className="sidebar-button" 
                        size='small'
                        onClick={handleOption8Click} 
                    />
                </li>
                <li>
                    <Button 
                        label="Configuraciones"
                        icon="pi pi-cog"
                        className="sidebar-button" 
                        size='small'
                        onClick={handleOption7Click} 
                    />
                </li>
            </ul>
        </Sidebar>
    );
};

export default MySidebar;
